module.exports = __webpack_public_path__ + "static/media/orders.5db67348.svg";